import {
  INIT_SERVICE_REQUEST,
  RESET_CUSTOMER_SERVICE_TYPE,
  RESET_CUSTOMER_SUPPORT_METHOD,
  RESET_CUSTOMER_SUPPORT_OPTION,
  SET_CUSTOMER_SUPPORT_METHOD,
  SET_CUSTOMER_SUPPORT_OPTION,
  SUBMIT_SERVICE_REQUEST_FORM_PENDING,
  SUBMIT_SERVICE_REQUEST_FORM_FULFILLED,
  SET_OPTIONS_COUNT,
  SET_SUPPORT_FORM,
  SET_SHOW_CALL_BACK_MODAL,
  SET_HIDE_CALL_BACK_MODAL,
  SET_SHOW_CONTACT_MODAL,
  SET_HIDE_CONTACT_MODAL,
  SUBMIT_CALL_BACK_REQUEST_PENDING,
  SUBMIT_CALL_BACK_REQUEST_FULFILLED,
  SUBMIT_CALL_BACK_REQUEST_FAILED,
  SUBMIT_CONTACT_BACK_CASE_PENDING,
  SUBMIT_CONTACT_BACK_CASE_FULFILLED,
  SUBMIT_CONTACT_BACK_CASE_FAILED,
} from "constants-lib/actionTypes"
import { API_STATUSES } from "constants-lib/common"

export const initialState = {
  optionsCount: 0,
  formSubmissionState: ``,
  supportMethod: null,
  supportOptionIndex: null,
  step: 0,
  steps: [],
  showCallBackModal: false,
  showContactModal: false,
  submitCallbackRequestStatus: "",
  submitCallbackRequestData: {},
  contactBackAttributesStatus: "",
  contactBackAttributesData: {},
  contactBackCreateCase: "",
  contactBackCreateCaseData: {},
}
export default (state = initialState, action) => {
  switch (action.type) {
    case INIT_SERVICE_REQUEST:
      return initialState

    case RESET_CUSTOMER_SERVICE_TYPE:
      return initialState

    case RESET_CUSTOMER_SUPPORT_METHOD:
      return initialState

    case RESET_CUSTOMER_SUPPORT_OPTION:
      return {
        ...state,
        supportOptionIndex: initialState.supportOptionIndex,
        step: 1,
        formSubmissionState: initialState.formSubmissionState,
      }

    case SET_CUSTOMER_SUPPORT_METHOD:
      return {
        ...state,
        supportMethod: action.payload,
        step: 1,
        formSubmissionState: initialState.formSubmissionState,
      }

    case SET_CUSTOMER_SUPPORT_OPTION: {
      return {
        ...state,
        supportOptionIndex: action.payload.option,
        step: action.payload.step,
        steps: action.payload.steps,
      }
    }

    case SUBMIT_SERVICE_REQUEST_FORM_PENDING:
      return {
        ...state,
        formSubmissionState: API_STATUSES.PENDING,
      }

    case SUBMIT_SERVICE_REQUEST_FORM_FULFILLED:
      return {
        ...state,
        formSubmissionState: API_STATUSES.FULFILLED,
      }

    case SET_OPTIONS_COUNT:
      return {
        ...state,
        optionsCount: action.payload,
      }

    case SET_SUPPORT_FORM:
      return {
        ...state,
        optionsCount: 3,
        step: 3,
        steps: [`other_new_service`, `request_new_service`, `services`],
        supportMethod: `services`,
        supportOptionIndex: `other_new_service`,
      }

    case SET_SHOW_CALL_BACK_MODAL:
      return {
        ...state,
        showCallBackModal: true,
      }

    case SET_HIDE_CALL_BACK_MODAL:
      return {
        ...state,
        showCallBackModal: false,
      }
    case SET_SHOW_CONTACT_MODAL:
      return {
        ...state,
        showContactModal: true,
      }

    case SET_HIDE_CONTACT_MODAL:
      return {
        ...state,
        showContactModal: false,
      }

    case SUBMIT_CALL_BACK_REQUEST_PENDING:
      return {
        ...state,
        submitCallbackRequestStatus: API_STATUSES.PENDING,
      }

    case SUBMIT_CALL_BACK_REQUEST_FULFILLED:
      return {
        ...state,
        submitCallbackRequestStatus: API_STATUSES.FULFILLED,
        submitCallbackRequestData: action.payload,
      }

    case SUBMIT_CALL_BACK_REQUEST_FAILED:
      return {
        ...state,
        submitCallbackRequestStatus: API_STATUSES.FAILED,
      }

    case SUBMIT_CONTACT_BACK_CASE_PENDING:
      return {
        ...state,
        contactBackCreateCaseStatus: API_STATUSES.PENDING,
      }

    case SUBMIT_CONTACT_BACK_CASE_FULFILLED:
      return {
        ...state,
        contactBackCreateCaseStatus: API_STATUSES.FULFILLED,
        contactBackCreateCaseData: action.payload,
      }

    case SUBMIT_CONTACT_BACK_CASE_FAILED:
      return {
        ...state,
        contactBackCreateCaseStatus: API_STATUSES.FAILED,
      }

    default:
      return state
  }
}
